import { MIP_MANAGE_ROUTES } from '@dealstack/frontend/app/pages/Routing/routes.ts';
import { mipManagePath } from '@dealstack/frontend/app/pages/Routing/routes.utils.ts';
import { BreadcrumbDropdown } from '@dealstack/frontend/shared/components/BreadcrumbDropdown';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { SummaryDealMip } from '@dealstack/shared/lib/generated';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { memo, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { MantineMenuItemProps } from '@dealstack/frontend/shared/components/MantineMenu/MantineMenu.types';

interface Props {
	currentDealId?: string;
	currentMipId?: string;
	mips: SummaryDealMip[];
	createNewMip: () => void;
}

const MipDropdown = ({ currentDealId, currentMipId, mips, createNewMip }: Props) => {
	const tCommonUi = useTranslationCommonUi();
	const navigate = useNavigate();

	const currentProjectName = useMemo(() => {
		return mips?.find((d) => d.id === currentMipId)?.programmeName || 'Draft MIP';
	}, [mips, currentMipId]);

	const items: MantineMenuItemProps[] | undefined = mips?.map((item) => {
		const isSelected = item.id === currentMipId;
		return {
			key: item.id,
			label: item.programmeName ?? 'Draft MIP',
			dataTestId: item.programmeName ?? item.id,
			className: isSelected ? 'selected' : '',
			onClick: () => {
				const route = mipManagePath(MIP_MANAGE_ROUTES.INVESTORS, {
					dealId: currentDealId ?? '',
					mipId: item.id,
				});
				navigate(route);
			},
			rightSection: isSelected ? <Icon variant="tick" size="lg" /> : undefined,
		};
	});

	const bottomSectionItems: MantineMenuItemProps[] = [
		{
			key: 'new-mip',
			dataTestId: TEST_ELEMENT_IDS.BREADCRUMB_DROPDOWN_NEW_INVESTMENT_PROGRAMME,
			label: tCommonUi('breadcrumbs.deal_dropdown.create_mip'),
			onClick: () => createNewMip(),
			icon: <Icon variant="add" size="lg" />,
		},
	];

	const targetHref = mipManagePath(MIP_MANAGE_ROUTES.INVESTORS, {
		dealId: currentDealId ?? '',
		mipId: currentMipId ?? '',
	});

	return (
		<BreadcrumbDropdown
			targetHref={targetHref}
			targetTitle={currentProjectName}
			items={items}
			bottomSectionItems={bottomSectionItems}
			breadcrumbType="programme"
		/>
	);
};
const _MipDropdownExport = memo(MipDropdown);

export { _MipDropdownExport as MipDropdown };
